export default {
  pagination: {},
  sales: [],
  sale: {},
  totalAmount: 0,
  totalCount: 0,
  totalAmountBillet: 0,
  totalBillet: 0,
  salesFilters: null,
  filterDates: [],
  initiateCheckout: [],
  installments: {},
  datePickerType: "range"
};
